document.querySelectorAll('.info-card__show').forEach(btn => {
    btn.addEventListener('click', () => {
        btn.classList.toggle('is-active');

        const card = btn.closest('.info-card');
        if (card) {
            card.querySelector('.tags').classList.toggle('is-active');
        } else {
            const header = btn.closest('.form__header');
            if (header) {
                header.querySelector('.form__more').classList.toggle('is-active');
            }
        }
    });
});
